<template>
    <div>
        <div v-if="$root.user.active">
            
            <div class="row head">
                <div class="col col-100">Huidig abonnement</div>
            </div>
            
            <div v-for="(subscription, index) in subscriptions">
                <div v-if="index == 1" class="row head">
                    <div class="col col-100">Nieuwe abonnement</div>
                </div>
                <div v-if="index == 0 && $root.app.platform == 'ios' && subscription.swappable">
                    <router-link :to="'/subscription/'+subscription.id+'/options'">
                        <div class="row setting subscription" v-bind:class="{'row-single': subscriptions.length - 1 === index }">
                            <div class="avatar" v-bind:class="'avatar--'+subscription.icon"></div>
                            <div class="account-info col">
                                <div class="table">
                                    <div class="cell">
                                        <div class="account-info__title">{{ subscription.name }}</div>
                                        <div class="account-info__subtitle">
                                            <p>{{ subscription.description }}</p>
                                            <p><em>{{ subscription.salesLine1 }}</em></p>
                                            <p class="account-info__subtitle--large">{{ subscription.price }} exclusief btw p/m</p>
                                        </div>
                                        <p v-if="subscription.status == 'cancelled'" class="info info--2">
                                            <i class="icon icon-close"></i>Verloopt op {{subscription.expireTime}}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </router-link>
                </div>    
                <div v-else>
                    <div class="row has-subitem setting subscription" v-bind:class="{'row-last': subscriptions.length - 1 === index }">
                        <div class="avatar" v-bind:class="'avatar--'+subscription.icon"></div>
                        <div class="account-info">
                            <div class="table">
                                <div class="cell">
                                    <div class="account-info__title">{{ subscription.name }}</div>
                                    <div class="account-info__subtitle">
                                        <p>{{ subscription.description }}</p>
                                        <p><em>{{ subscription.salesLine1 }}</em></p>
                                        <p class="account-info__subtitle--large">{{ subscription.price }} exclusief btw p/m</p>
                                    </div>                             
                                    <div v-if="subscription.swappable == false && subscription.status == 'active'">
                                        <p class="info info--1"><i class="icon icon-clock"></i>Gaat in op {{subscription.startTime}}</p>
                                        <p class="info info--4"><i class="icon icon-exclamation"></i>Je kunt over {{subscription.swapCooldown}} dagen weer wijzigen</p>
                                    </div>
                                    <p v-if="subscription.status == 'cancelled'" class="info info--2">
                                        <i class="icon icon-close"></i>Verloopt op {{subscription.expireTime}}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div v-if="subscription.status == 'cancelled' && subscriptions.length == 1">
                    
                    <div class="row spacer">&nbsp;</div>
                    <div class="row row-button">
                        <div class="col col-100">
                            <button  class="button button--alt" @click="reactivate_subscription(subscription.id)">Abonnement heractiveren</button>
                        </div>
                    </div>
                    
                </div>
                <div v-else>
                    
                    <router-link v-if="subscription.swappable" :to="'/subscription/'+subscription.id+'/options'">
                        <div class="row spacer">&nbsp;</div>
                        <div class="row row-button has-subitem">
                            <div class="col col-100">
                                <button  class="button button--alt">Abonnement wijzigen</button>
                            </div>
                        </div>
                    </router-link>

                    <div class="row spacer">&nbsp;</div>
                    
                    <div class="row row-button row-button--bottom">
                        <div class="col col-100">
                            <button class="button" @click="cancel_subscription(subscription.id)">Abonnement opzeggen</button>
                        </div>
                    </div>
                    
                </div>
                
            </div>
            
        </div>
        <div v-else>
            <div class="row setting explanation notice">
                <div class="col col-100">
                    <b>Inactief account</b><br>
                    Uw abonnement is verlopen. <br/>Wilt u een nieuw abonnement? Neem dan contact op met onze helpdesk via 'Ondersteuning'.
                </div>
            </div>
        </div>
        
        <div class="row spacer" v-if="$root.app.platform == 'ios'">&nbsp;</div>
        
    </div>
</template>

<script>
    export default {
    name: 'Subscriptions',
        data () {
            
            return {
                subscriptions: {},
                subscriptionOptions: {}
            }
        },
        
        mounted(){
            
            
        },
        
        created(){
            
            this.getSubscriptions();
        },
        
        methods:{  
            
            cancel_subscription: function(id){
                
                var root = this.$root;
                var _this = this;
                
                _this.$root.ui.showDialog(
                    'Opzeggen',
                    '<p>Je abonnement zal aan het <b>eind van de huidige maand</b> verlopen. </br>Je kunt dan niet meer bellen of gebeld worden op jouw Dubline nummer(s).</p>' +
                    '<p>Weet je het zeker?</p>' +
                    '<p>Reden van opzeggen:</p>' +
                    '<select id="reason" onchange="(function(value) { document.getElementById(\'textarea\').style.display = (value === \'Anders\' ? \'block\' : \'none\'); })(this.value)">' +
                     '<option disabled selected>Selecteer</option>' +
                     '<option value="Ik maak geen gebruik meer van Dubline">Ik maak geen gebruik meer van Dubline</option>' +
                     '<option value="Ik heb een andere oplossing gevonden">Ik heb een andere oplossing gevonden</option>' +
                     '<option value="Ik heb een probleem met Dubline">Ik heb een probleem met Dubline</option>' +
                     '<option value="Anders">Anders..</option>' +
                    '</select>' +
                    '<p><textarea rows="2" id="textarea" placeholder="Typ hier je reden" style="display: none;border-radius: 0;"></textarea></p>',
                    false,
                    {
                        0:{
                            name: 'Opzeggen',
                            execute: function(){
                                
                                var subscriptionID = id;
                                var reason = document.getElementById('reason').value;
                                reason = reason == 'Anders' ? reason + ': ' + document.getElementById('textarea').value : reason;
                                root.loading = true;
                                _this.$api.post('/subscription/cancel', {
                                    id: subscriptionID,
                                    reason: reason
                                })
                                .then(response => {
                                    
                                    _this.getSubscriptions();
                                    
                                    root.loading = false;
                                    
                                    _this.$root.ui.showDialog(
                                        'Voltooid',
                                        'Je abonnement is opgezegd. Deze verloopt aan het <b>eind van de huidige maand</b>.',
                                        true
                                    );
                                })
                                .catch(e => {
                            
                                    root.loading = false;
                                    
                                    _this.$root.ui.showDialog(
                                        'Fout',
                                        e.response.data.message,
                                        true
                                    );
                                })
                            }
                        },
                        1:{
                            name: 'Annuleren',
                            execute: function(){}
                        }
                    }                    
                );
            },
            
            reactivate_subscription: function(id){
                
                var root = this.$root;
                var _this = this;
                
                _this.$root.ui.showDialog(
                    'Abonneren', 
                    '<p>Je abonnement zal direct hervat worden.</p>'
                    +'<p>Weet je het zeker?</p>',
                    false,
                    {
                        0:{
                            name: 'Activeren',
                            execute: function(){
                                
                                var subscriptionID = id;
                                
                                root.loading = true;
                                _this.$api.post('/subscription/reactivate', {
                                    id: subscriptionID
                                })
                                .then(response => {
                                    
                                    _this.getSubscriptions();
                                    
                                    root.loading = false;
                                    
                                    _this.$root.ui.showDialog(
                                        'Voltooid',
                                        'Je abonnement is succesvol geactiveerd.',
                                        true
                                    );
                                })
                                .catch(e => {
                            
                                    root.loading = false;
                                    
                                    _this.$root.ui.showDialog(
                                        'Fout',
                                        e.response.data.message,
                                        true
                                    );
                                })
                            }
                        },
                        1:{
                            name: 'Annuleren',
                            execute: function(){}
                        }
                    }                    
                );
            },
            
            getSubscriptions(){
                
                this.$api.get('/subscriptions')
                .then(response => {

                    this.subscriptions = response.data;
                })
                .catch(e => {

                }) 
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/Subscriptions.vue